import React, { useEffect } from 'react'

const EQuoteSearchFiltersFullFormGuestCount = ({
  handleSelectGuestCount,
  guestCount,
  activeBrand,
  voyageType,
  isRiverShip
}) => {
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (isRiverShip && Number(guestCount) > 2) {
      handleSelectGuestCount(2)
    } else if (activeBrand === 'Z' && Number(guestCount) === 4) {
      handleSelectGuestCount(3)
    }
  }, [activeBrand, guestCount, isRiverShip])

  const isDisabled = value => isRiverShip && value > 2

  return (
    <div className="equote__search-filters-form-field-input u-custom-select">
      <select
        name="guestCount"
        onChange={e => handleSelectGuestCount(parseInt(e.target.value))}
        value={guestCount}
        tabIndex={0}
        aria-labelledby="guestCountToggleLabel"
      >
        <option value="1">Number of Guests: 1</option>
        <option value="2">Number of Guests: 2</option>
        <option value="3" disabled={isDisabled(3)}>
          Number of Guests: 3
        </option>
        {activeBrand !== 'Z' && (
          <option value="4" disabled={isDisabled(4)}>
            Number of Guests: 4
          </option>
        )}
      </select>
      <span className="u-custom-select__arrow" />
    </div>
  )
}

export default EQuoteSearchFiltersFullFormGuestCount
